var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Menubar',{attrs:{"id":"navBar","model":_vm.items},scopedSlots:_vm._u([{key:"end",fn:function(){return [_c('Button',{style:({ 'margin-left': '0 .5em' }),attrs:{"label":"Login","icon":"pi pi-sign-in"},on:{"click":_vm.toggleLogin}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }